import { Component, Input } from '@angular/core';
import { BenefitCard } from 'src/app/model/card/benefit-card';

@Component({
  selector: 'app-benefit-card',
  templateUrl: './benefit-card.component.html',
  styleUrls: ['./benefit-card.component.scss']
})
export class BenefitCardComponent {
  @Input() benefitCards: BenefitCard[] = [];
  constructor() {}
}
